import PoliciesGrid from './policies-grid';
import { pagesConfig } from '../../shared/pages-config';
import { useUserSettings } from '../../utils/use-user-settings';
import SimpleBreadcrumbsPage from '../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../shared/analytics/module-list';
import { useRouteMatch } from '../../shared/useRouteMatch';
import { Outlet } from 'react-router-dom';

export default function PoliciesPage() {
  const { toolsRoles, changeLogRoles } = useUserSettings();

  const isFormPage = useRouteMatch([
    `${pagesConfig.policies.link}/${pagesConfig.createPolicy.link}`,
    `${pagesConfig.policies.link}/${pagesConfig.editPolicy.link}`,
    `${pagesConfig.policies.link}/${pagesConfig.clonePolicy.link}`,
  ]);

  if (isFormPage) return <Outlet />;

  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.automation.name },
        { label: pagesConfig.policies.name },
      ]}
      bookmarkKey={pagesConfig.policies.value}
    >
      <PoliciesGrid toolsRoles={toolsRoles} changeLogRoles={changeLogRoles} />
    </SimpleBreadcrumbsPage>
  );
}
